import { BellAlertIcon } from "@heroicons/react/24/solid";
import { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { Typography } from "@/core/components/ui/typography";
import { DetailedUser } from "@/user/user";

const TechnicianCol = <
  T extends Pick<
    DetailedUser,
    "display_identification" | "spiff_review_requested_at"
  >,
>(): ColumnDef<T> => ({
  id: "technician-with-request",
  header: "Technician",
  enablePinning: true,
  size: 150,
  meta: {
    size: "150px",
  },
  accessorFn: (row) => row.display_identification,
  cell: ({ row }) => {
    const hasReviewRequested = !!row.original.spiff_review_requested_at;

    return (
      <Stack direction="row" gap="sm" align="center">
        <Typography variant="bodyW1">
          {row.original.display_identification}
        </Typography>
        {hasReviewRequested && (
          <Tooltip>
            <TooltipTrigger asChild>
              <BellAlertIcon className="size-4 min-w-4 fill-fill-negative" />
            </TooltipTrigger>
            <TooltipContent>Payment requested</TooltipContent>
          </Tooltip>
        )}
      </Stack>
    );
  },
});

export default TechnicianCol;
